import globalutil from 'src/util/globalutil';

export const addGlobalUtils = (data) => {
  globalutil.setdastatuses(data.dastatuses);
  globalutil.setstates(data.states);
  globalutil.setmakes(data.makes);
  globalutil.setdocument_types(data.document_types);
  globalutil.setuserroles(data.userroles);
  globalutil.setcountries(data.countries);
  globalutil.setbusinesstypes(data.businesstypes);
  globalutil.setproductgroups(data.productgroups);
  globalutil.setsubstatuses(data.substatuses);
  globalutil.setauditentities(data.auditentities);
  globalutil.setbusinessentities(data.businessentities);
  globalutil.setnotificationtypes(data.notificationtypes);
  globalutil.setcategories(data.categories);
  globalutil.setservicetypes(data.servicetypes);
  globalutil.setvehicletypes(data.vehicletypes);
  globalutil.setownerships(data.ownerships);
  globalutil.setmenus(data.menus);
  globalutil.setcommonstatuses(data.commonstatuses);
  globalutil.setworkblocktypes(data.workblocktypes);
  globalutil.setvehiclestatuss(data.vehiclestatuss);
  globalutil.setinspectionstatuses(data.inspectiontypes);
  globalutil.setinspectionitems(data.inspectionitems);
  globalutil.setdatatypes(data.datatypes);
  globalutil.setfieldtypes(data.fieldtypes);
  globalutil.setsynchstatuses(data.synchstatuses);
  globalutil.setrostertypes(data.rostertypes);
  globalutil.setdsP_TABLES(data.dsP_TABLES);
  globalutil.setproduct_assignment_types(data.product_assignment_types);
  globalutil.setnotificationcategories(data.notificationcategories);
  globalutil.setsuffixes(data.suffixes);
  globalutil.setviolationtypes(data.violationtypes);
  globalutil.setdelivery_statuses(data.delivery_statuses);
  globalutil.setrosterstatuses(data.rosterstatuses);
  globalutil.setuniformsizes(data?.uniform_sizes || []);
  globalutil.setmaintenancestatuses(data?.maintenancestatuses || []);
  globalutil.setmaintenancetasks(data?.maintenancetasks || []);
};
